import { useCallback } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { loader } from "../../../loader";
import { putData } from "../../../axios/apiHelper";

export default function VwdEditProfileReview() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleBackClick = useCallback((e) => {
    e.preventDefault();
    navigate("/vwd/edit-profile", {
      state: { ...state, action: "back" },
    });
  }, []);

  const handleCloseClick = useCallback((e) => {
    e.preventDefault();
    navigate("/vwd/profile");
  }, []);

  const handleSaveClick = useCallback(async (e) => {
    e.preventDefault();

    try {
      loader("show");
      const payload = {
        id: state.id,
        name: state.name,
        ibt: state.ibt,
        country: state.country,
        region: state.region,
        company: state.company,
        role: state.role,
      };

      await putData("/vwd/update-user-data", payload);
      navigate("/vwd/profile");
    } catch (err) {
      console.log("Error while updating user data : ", err);
    } finally {
      loader("hide");
    }
  }, []);

  return (
    <Col className="right-sidebar custom-change">
      <div className="custom-container">
        <Row>
          <div className="page-top-nav sticky">
            <Row className="row justify-content-end align-items-center">
              <Col md="1">
                <div className="header-btn-left">
                  <button
                    className="btn btn-primary btn-bordered back"
                    onClick={handleBackClick}
                  >
                    Back
                  </button>
                </div>
              </Col>
              <Col md="9">
                <ul className="tabnav-link">
                  <li className="">
                    <a href="">Edit Profile</a>
                  </li>
                  <li className="active active-main">
                    <a href="">Review &amp; approve</a>
                  </li>
                </ul>
              </Col>
              <Col md="2">
                <div className="header-btn justify-content-end align-items-center">
                  <button
                    className="btn btn-primary btn-bordered move-draft"
                    onClick={handleCloseClick}
                  >
                    Close
                  </button>
                  <Button
                    className="btn btn-primary btn-filled next send_btn"
                    onClick={handleSaveClick}
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <div className="crm-detail">
            <div className="crm-detail-content">
              <h4>Profile Details</h4>
              <div className="crm-review">
                <div className="crm-review-detail">
                  <table className="tab-mail-list">
                    <tbody>
                      <tr>
                        <th className="tab-content-title">Name</th>
                        <td>{state.name}</td>
                      </tr>
                      <tr>
                        <th className="tab-content-title">Email </th>
                        <td>{state.email}</td>
                      </tr>
                      <tr>
                        <th className="tab-content-title">Type</th>
                        <td>{state.type}</td>
                      </tr>
                      <tr>
                        <th className="tab-content-title">IBT</th>
                        <td>{state.ibt ? "Yes" : "No"}</td>
                      </tr>
                      <tr>
                        <th className="tab-content-title">Role</th>
                        <td>{state.role}</td>
                      </tr>
                      <tr>
                        <th className="tab-content-title">Region</th>
                        <td>{state.region}</td>
                      </tr>
                      <tr>
                        <th className="tab-content-title">Country</th>
                        <td>{state.country}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Row>
      </div>
    </Col>
  );
}
